<script setup lang="ts">
  import * as Sentry from '@sentry/vue';
  import { onBeforeMount } from 'vue';

  import { DocumentUser } from '~/types';

  const { mdu } = defineProps<{
    mdu: DocumentUser;
  }>();
  onBeforeMount(() => {
    setUpSentry();
  });

  const setUpSentry = () => {
    Sentry.setUser({
      document_user_id: mdu.uuid,
      document_user_email: mdu.email,
      account_id: mdu.account_user?.account?.uuid,
    });
  };
</script>

<template>
  <slot />
</template>
